import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addBudgetFailure,
  addBudgetSuccess,
  //
  deleteBudgetSuccess,
  deleteBudgetFailure,
  //
  editBudgetSuccess,
  editBudgetFailure,
  //
  fetchBudget as fetchBudgetAction,
  fetchBudgetFailure,
  fetchBudgetSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  copyBudgetSuccess,
  copyBudgetFailure,
  bulkUpdateSuccess,
  bulkUpdateFailure,
  getBudgetHistorySuccess,
  getBudgetHistoryFailure,
} from "./actions";
import {
  ADD_BUDGET,
  EDIT_BUDGET,
  DELETE_BUDGET,
  FETCH_BUDGET,
  GET_VIEW_DATA,
  COPY_BUDGET,
  BULK_UPDATE,
  GET_BUDGET_HISTORY,
} from "./constants";

export function* fetchBudgetSaga({
  payload = { cancelToken: null },
  onBudgetSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-role-weekly-budget?${query}`,
      payload
    );
    yield put(fetchBudgetSuccess(data));
    typeof onBudgetSuccess === "function" && onBudgetSuccess(data);
  } catch (e) {
    yield put(fetchBudgetFailure());
    typeof onBudgetSuccess === "function" && onBudgetSuccess([]);
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching shift!"));
  }
}

export function* getViewDataSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-role-weekly-budget/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addBudgetSaga({ payload, onBudgetAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/location-role-weekly-budget/add`,
      payload
    );
    yield put(successAlert("Budget added successfully!"));
    yield put(addBudgetSuccess());
    typeof onBudgetAdd === "function" && onBudgetAdd(data);
  } catch (e) {
    yield put(addBudgetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editBudgetSaga({ payload, onBudgetEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-role-weekly-budget/edit/${payload.id}`,
      payload
    );
    yield put(successAlert("Budget updated successfully!"));
    yield put(editBudgetSuccess());
    typeof onBudgetEdit === "function" && onBudgetEdit();
  } catch (e) {
    yield put(editBudgetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteBudgetSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/location-role-weekly-budget/${payload}`
    );
    if (data) {
      yield put(successAlert("Budget deleted successfully!"));
      yield put(deleteBudgetSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteBudgetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* copyBudgetSaga({ payload, onCopySuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-role-weekly-budget-copy`,
      payload
    );
    if (data) {
      yield put(successAlert("Budget copied successfully!"));
      yield put(copyBudgetSuccess());
      typeof onCopySuccess === "function" && onCopySuccess();
    }
  } catch (e) {
    yield put(copyBudgetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* bulkUpdateSaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/bulk-staff-allocation`,
      payload
    );
    if (data) {
      yield put(bulkUpdateSuccess());
    }
    typeof onUpdate === "function" && onUpdate();
  } catch (e) {
    yield put(bulkUpdateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getBudgetHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-role-weekly-budget-history/${payload.id}`
    );
    yield put(getBudgetHistorySuccess(data));
  } catch (e) {
    yield put(getBudgetHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* fetchBudgetFlow() {
  yield takeEvery(FETCH_BUDGET, fetchBudgetSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addBudgetFlow() {
  yield takeEvery(ADD_BUDGET, addBudgetSaga);
}
export function* editBudgetFlow() {
  yield takeEvery(EDIT_BUDGET, editBudgetSaga);
}
export function* deleteBudgetFlow() {
  yield takeEvery(DELETE_BUDGET, deleteBudgetSaga);
}
export function* copyBudgetFlow() {
  yield takeEvery(COPY_BUDGET, copyBudgetSaga);
}
export function* bulkUpdateFlow() {
  yield takeEvery(BULK_UPDATE, bulkUpdateSaga);
}
export function* getBudgetHistoryFlow() {
  yield takeEvery(GET_BUDGET_HISTORY, getBudgetHistorySaga);
}

export default function* BudgetSaga() {
  yield all([
    fetchBudgetFlow(),
    addBudgetFlow(),
    editBudgetFlow(),
    deleteBudgetFlow(),
    getViewDataFlow(),
    copyBudgetFlow(),
    bulkUpdateFlow(),
    getBudgetHistoryFlow(),
  ]);
}
